<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog persistent v-model="dialog" style="/*this is not yet working*/min-width: 580px;" width="unset"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="myForm" v-on:submit.prevent="createtask" :disabled="saving">
      <v-card :min-width="$vuetify.breakpoint.xs ? '100vw' : '600px'" style="min-height: 300px;">
        <v-card-title dense class="text-center justify-center">
          <div class="text-h3">{{ language.t('RobotPlotter.CreateTask.createTask') }}</div>
        </v-card-title>

        <v-card-text v-if="error" class="d-flex text-center justify-center pa-0">
          <v-alert v-if="error" dense type="warning" dismissible
            style="white-space: normal; word-break: break-word; max-width: 550px;">{{ error }}</v-alert>
        </v-card-text>

        <div v-if="success">
          <v-card-text class="text-center justify-center py-6">
            <v-alert dense type="success">{{ language.t('RobotPlotter.CreateTask.taskSaved') }}</v-alert>
          </v-card-text>

          <v-card-actions class="card-actions">
            <v-spacer></v-spacer>
            <v-btn v-on:click="closeDialog()" :disabeled="loading">
              <v-icon>mdi-close</v-icon>{{ "Close" }}
            </v-btn>
            <v-btn v-on:click="clearForm()" :disabeled="loading">
              <v-icon>mdi-folder-plus-outline</v-icon>{{ language.t('RobotPlotter.CreateTask.newTask') }}
            </v-btn>
            <v-btn v-on:click="openTask()" :loading="loading">
              <v-icon>mdi-map-search-outline</v-icon>{{ language.t('RobotPlotter.CreateTask.viewTask') }}
            </v-btn>
          </v-card-actions>
        </div>

        <div v-show="!success">
          <v-card-text class="text-center justify-center py-6">

            <v-alert dense type="error" width="580px" :value="fileSupported !== true"> {{ fileSupported }}</v-alert>

            <v-layout v-if="form.file && form.type != 'dxf' && form.type != 'motionplan' && hasMotionplanSpraypoints"
              class="py-3" row wrap align-center justify-center manditory>
              <v-btn-toggle v-model="form.type" return-object>
                <v-flex v-for="option in typeOptions" :key="option.id">
                  <v-btn large color='orange' text :value="option.value">{{ option.name }}</v-btn>
                </v-flex>
              </v-btn-toggle>
            </v-layout>


            <DragAndDropFile :dxffile="form.file" v-on:fileUpdate="onFileUpdate"></DragAndDropFile>

            <!-- <v-file-input v-model="form.file" ref="fileupload"
              :placeholder="language.t('RobotPlotter.CreateTask.chooseFile')" @change="onSelectFile"
              accept=".csv,.dxf,.log" truncate-length="15" :rules="[fileSupported]">
            </v-file-input> -->

            <v-container class="pa-0" v-if="form.file && form.type != 'dxf' && form.type != 'motionplan' && hasMotionplanSpraypoints">
              <v-row no-gutters>
                  <v-col >
                    <v-checkbox v-model="onlyLastContour" dense>
                      <template v-slot:label>
                        <div class="d-flex align-center">
                          <span>
                            {{ language.t('RobotPlotter.CreateTask.onlyLastContour') }}
                          </span>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small class="ml-1" v-bind="attrs" v-on="on">
                                mdi-information-outline
                              </v-icon>
                            </template>

                            <span>
                              {{ language.t('RobotPlotter.CreateTask.onlyLastContourInfo') }}
                            </span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
              </v-row>
            </v-container>

            <v-container class="pa-0" v-if="form.file">
              <v-row no-gutters>
                <v-col v-if="hasMotionplanBasic && form.type == 'dxf'">
                  <v-checkbox v-model="changesSelected" :label="language.t('RobotPlotter.CreateTask.changes')"
                    dense></v-checkbox>
                </v-col>
                <v-col>
                  <!-- <v-alert type="info" elevation="0" dense>Unit: {{ currentFileUnit.name
                    }}</v-alert> -->
                  <UnitSelect v-model="currentFileUnit" />
                </v-col>
              </v-row>
            </v-container>

            

            <!-- <v-file-input
              v-if="form.type == 'dxfpoints' || form.type == 'points' || form.type == 'pointsWithBoundaries'"
              v-model="form.env_file" ref="fileuploadEnvironment"
              :placeholder="language.t('RobotPlotter.CreateTask.chooseFileEnvironment')" @change="checkAcadVerSupport"
              accept=".dxf" truncate-length="15" :rules="[fileSupported]"></v-file-input> -->

            <ProjectSelect v-model="form.project" />

            <ProjectionSelect v-if="!form.project || !form.project.projection" v-model="form.projection" />

            <v-select v-else :value="form.project.projection.code" :items="[form.project.projection]" item-text="name"
              item-value="code" single-line dense>
              <template slot="selection" slot-scope="data">{{ data.item.code }} - {{ data.item.name }}</template>
            </v-select>

            <v-text-field v-model="form.name" ref="name" :placeholder="language.t('RobotPlotter.CreateTask.taskName')"
              maxlength="45"></v-text-field>

            <v-text-field v-model="form.description" ref="description"
              :placeholder="language.t('RobotPlotter.CreateTask.description')"></v-text-field>

          </v-card-text>

          <v-card-actions class="card-actions">
            <v-spacer></v-spacer>
            <v-btn color="error" x-large v-on:click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn color="success" x-large type="submit" :disabled="!complete || saving || (fileSupported !== true)">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ProjectionSelect from "../formfields/ProjectionSelect";
import UnitSelect from "../formfields/UnitSelect";
import ProjectSelect from '../formfields/ProjectSelect'
import DragAndDropFile from '../formfields/DragAndDropFile'
//TODO: request update to dxf package.
import DXFFile from "../../webcomponents/models/DXFFile";
import * as CONST from "../../Constants";

export default {
  components: {
    ProjectionSelect,
    ProjectSelect,
    DragAndDropFile,
    UnitSelect
  },
  props: {},
  data() {
    return {
      isDragging: false,
      dialog: true,
      complete: false,
      saving: false,
      error: null,
      success: false,
      task: null,
      fileSupported: true,
      loading: false,

      form: {
        file: null,
        env_file: null,
        name: "",
        description: "",
        type: "",
        project: null,
        projection: this.$projections.default?.code || "EPSG:28992"
      },

      typeOptions: [
        //{ id: 0, name: "DXF", value: "dxf" },
        // { id: 1, name: "Punten (via motionplan)", value: "points" }, //"motionplan"
        // { id: 2, name: "Punten met boundary routes (via motionplan)", value: "pointsWithBoundaries" }, //"motionplan"
        // { id: 2, name: "Punten spuiten", value: "points" },
        // { id: 3, name: "Punten boren", value: "drill" },
        // { id: 4, name: "DXF", value: "dxfpoints" },
      ],
      changesSelected: true,
      onlyLastContour: true,
      currentFileUnit: { conversionId: 6, name: "Meters", conversion: 1 },
    };
  },
  mounted: function () {
    this.typeOptions = [];

    if (this.hasMotionplanSpraypoints) {
      this.typeOptions.push({ id: 1, name: "Motionplan", value: "points" })
      this.typeOptions.push({ id: 2, name: "Motionplan Boundary", value: "pointsWithBoundaries" })
      if (this.hasAdmin) {
        this.typeOptions.push({ id: 4, name: "DXF", value: "dxfpoints" })
      }
    } else {
      this.typeOptions.push({ id: 4, name: "DXF", value: "dxfpoints" })
    }

    // if no motionplan basic it should always be true
    // this.changesSelected = !this.hasMotionplanBasic // default is true now
  },
  computed: {
    hasDxfConnectDisconnectLines() {
      return this.$auth.functionGroups.includes(CONST.__FUNCTIONGROUP_DXFCONNECTDISCONNECTLINES)
    },
    hasMotionplanBasic() {
      return this.$auth.functionGroups.includes(CONST.__FUNCTIONGROUP_MOTIONPLANBASIC)
    },
    hasMotionplanSpraypoints() {
      return this.$auth.functionGroups.includes(CONST.__FUNCTIONGROUP_MOTIONPLANSPRAYPOINTS)
    },
    hasAdmin() {
      return this.$auth.functionGroups.includes(CONST.__FUNCTIONGROUP_ADMIN)
    }
  },
  watch: {
    form: {
      /* validate if the form data is complete */
      handler(val) {
        console.log(val)
        console.log(this.form.file && this.form.type != 'dxf' && this.form.type != 'motionplan')
        if (!!val.file && (!!val.projection || !!val.project?.projection) && !!val.type && !!val.name) this.complete = true;
        else this.complete = false;

      },
      deep: true,
    },
  },
  methods: {
    onFileUpdate(files) {
      let csvIndex = -1
      let hasCSV = files.some((file, i) => {
        csvIndex = i
        return file.type == "text/csv"
      });

      if (hasCSV) {
        this.form.file = files[csvIndex]
        this.onSelectFile(this.form.file)

        if (files.length > 1) {
          const envFile = files.at(csvIndex - 1);
          this.form.env_file = envFile

          if (envFile.size / (1024 * 1024) > 10) {
            this.error = this.language.t('RobotPlotter.CreateTask.warningLargeFile')
          }

        }
      } else {
        this.form.file = files[0]
        this.onSelectFile(this.form.file)
      }
    },
    closeDialog() {
      this.clearForm();
      this.$emit("close");
    },
    onSelectFile(file) {
      if (file == null) {
        this.form.type = "";
        this.fileSupported = true;
        this.currentFileUnit = { conversionId: 6, name: "Meters", conversion: 1 }
        return;
      }

      this.error = null;
      switch (file.type) {
        case "application/dxf":
          this.form.type = "dxf";
          break;
        case "application/vnd.ms-excel":
        case "text/csv":
          //Is filled by the choice selector
          // this.form.type = "";
          if (this.hasMotionplanSpraypoints) {
            this.form.type = 'points' // can select dxfpoints
          } else {
            this.form.type = 'dxfpoints' // can select dxfpoints
          }
          break;
        case "":
          // check file extension
          if (file.name.match(/\.[0-9a-z]+$/i)[0] == ".log") {
            this.form.type = "motionplan";
            break;
          }
          if (file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0] == ".dxf") {
            this.form.type = "dxf";
            break;
          }
        default:
          // check file extension
          if (file.name.match(/\.[0-9a-z]+$/i)[0] == ".log") {
            this.form.type = "motionplan";
            break;
          }
          if (file.name.match(/\.[0-9a-z]+$/i)[0] == ".csv") {
            if (this.hasMotionplanSpraypoints) {
              this.form.type = 'points' // can select dxfpoints
            } else {
              this.form.type = 'dxfpoints' // can select dxfpoints
            }
            break;
          }
          if (file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0] == ".dxf") {
            this.form.type = "dxf";
            break;
          }
      }
      // set taskname to filename if name is still empty
      if (this.form.name == "") {
        this.form.name = file.name.replace(/\.[^/.]+$/, "");
        this.form.name = this.form.name.substring(0, 45);
      }
      if (this.form.type === "dxf") {
        this.setDxfUnit(file)
        this.checkAcadVerSupport(file)
      }

    },
    setDxfUnit(file) {
      const reader = new FileReader();
      reader.onload = (res) => {
        var dxf = new DXFFile(res.target.result);
        const unit = this.$units.fromId(dxf.parsed.header.insUnits)
        this.currentFileUnit = unit;
      };
      reader.onerror = (err) => console.log(err);
      reader.readAsText(file);
    },
    checkAcadVerSupport(file) {
      this.layers = [];
      console.log("check file version");
      const reader = new FileReader();
      reader.onload = (res) => {
        var dxf = new DXFFile(res.target.result);
        if (CONST.__SUPPORTED_ACADVERS.indexOf(dxf.acadVer) !== -1) {
          this.fileSupported = true;
        } else {
          this.fileSupported = this.language.t("RobotPlotter.CreateTask.unsupportedVersion");
        }
      };
      reader.onerror = (err) => console.log(err);
      reader.readAsText(file);
    },
    createtask() {
      this.saving = true;
      this.error = null;
      let data = new FormData();
      var projection = this.form.project?.projection ? this.form.project.projection.code : this.form.projection;

      data.set("file", this.form.file);
      if (this.form.project) {
        data.set("project", this.form.project.projectId);
      }
      data.set("projection", projection);
      data.set("name", this.form.name);
      data.set("description", this.form.description);
      data.set("type", this.form.type);
      data.set("env_file", this.form.env_file);
      data.set("changes", this.changesSelected);
      data.set("unit", this.currentFileUnit.conversionId)

      if (this.onlyLastContour && (this.form.type == "points" ||  this.form.type == "pointsWithBoundaries") ){
        data.set("contour_usage_mode", "LAST_ONLY")
      }


      this.$axios
        .post(route("api.tasks.rbp"), data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          this.$emit("taskCreated");
          this.task = res.data;
          this.success = true;
          this.saving = false;
        })
        .catch((error) => {
          this.saving = false;
          console.log(error.response.data);
          if (error.response.data.error) this.error = error.response.data.error;
          else this.error = "unknown server error";
        });
    },
    openTask() {
      this.loading = true;
      if ((this.form.type == "points" && this.form.env_file) || (this.form.type == "pointsWithBoundaries" && this.form.env_file)) {
        console.log("OPENWITHDELAY")
        setTimeout(() => {
          this.$emit("openTask", this.task.taskId);
          this.loading = false;
          this.closeDialog();
        }, 3000);
      } else {
        this.$emit("openTask", this.task.taskId);
        this.loading = false;
        this.closeDialog();
      }
    },
    clearForm() {
      // this.$refs.fileupload.reset();
      this.form.file = null;
      this.form.projection = this.$projections.default?.code;
      this.form.name = "";
      this.form.description = "";
      this.form.type = "";
      this.error = null;
      this.success = false;
    },
  },
};
</script>

<style scoped></style>
